export const ADD_NFT_WALLET_MESSAGE =
  "Sign below to add this wallet's supported nfts to your Avatar and Sticker Collections."
